import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-023ee04c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mixed"
}
const _hoisted_3 = {
  key: 1,
  class: "d-mixed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_mixed = _resolveComponent("item-mixed")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_ctx.mixedData.length || _ctx.dataLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_item_wrapper, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isNetwork ? _ctx.$localize('drive.network.files.title') : _ctx.$localize('drive.section.files.title')), 1)
          ]),
          control: _withCtx(() => [
            _createElementVNode("span", {
              class: "black-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAllFiles && _ctx.viewAllFiles(...args)))
            }, _toDisplayString(_ctx.$localize('drive.section.button.view_all')), 1)
          ]),
          main: _withCtx(() => [
            (_ctx.mainStore.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_item_mixed, {
                    row: "",
                    mixedList: _ctx.mixedData,
                    column: !_ctx.driveStore.isGridPhotoView,
                    skeleton: _ctx.dataLoading,
                    loading: _ctx.isPageLoading,
                    onRemoveFromSearch: _ctx.removeFromSearch
                  }, null, 8, ["mixedList", "column", "skeleton", "loading", "onRemoveFromSearch"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_item_mixed, {
                    row: "",
                    mixedList: _ctx.mixedData,
                    column: !_ctx.driveStore.isGridPhotoView,
                    skeleton: _ctx.dataLoading,
                    loading: _ctx.isPageLoading,
                    onRemoveFromSearch: _ctx.removeFromSearch
                  }, null, 8, ["mixedList", "column", "skeleton", "loading", "onRemoveFromSearch"])
                ]))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}